export const absoluteUrlRegex = /^((http|https):\/\/).*$/;
